export default __webpack_public_path__ + "static/media/legend-1.f2582f51.svg";